/**
 * Created by XUQIANG on 2016/4/1.
 * action 中type定义
 */
//语言类型
export const CHINESE = 'zh_CN';
export const ENGLISH = 'en_US';
export const CHINESE_HK = 'zh_HK';

export const COMMA = ',';
export const SEMICOLON = ';';

//打开登录div
export const OPEN_LOGIN = 'OPEN_LOGIN';
//打开注册div
export const OPEN_SIGN = 'OPEN_SIGN';
//注册激活
export const SIGN_ACTIVE = 'SIGN_ACTIVE';
//找回密码
export const FIND_PASSWORD = 'FIND_PASSWORD';
export const REST_PASSWORD = 'REST_PASSWORD';

//会议室类型 0.普通会议室,1.WebEx会议室,2.Acano会议室,3.Exchange会议室,4.Domino|Notes会议室,5.Google Calendar会议室
export const MEETING_ROOM_CATEGORY = {
  ENGLISH: [
    'Common Room',
    'WebEx Room',
    'Acano Room',
    'Exchange Room',
    'Domino|Notes Room',
    'Google Calendar Room'
  ],
  CHINESE: [
    '普通会议室',
    'WebEx会议室',
    'Acano会议室',
    'Exchange会议室',
    'Domino|Notes会议室',
    'Google Calendar会议室'
  ]
};
export const WEEKDAY = {
  ENGLISH: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
  CHINESE: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
};

export const WEEK = {
  ENGLISH: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
  CHINESE: ['一', '二', '三', '四', '五', '六', '日']
};

export const MONTH = {
  ENGLISH: [
    'Jan',
    'Feb',
    'March',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],
  CHINESE: [
    '一月',
    '二月',
    '三月',
    '四月',
    '五月',
    '六月',
    '七月',
    '八月',
    '九月',
    '十月',
    '十一月',
    '十二月'
  ]
};

//服务资源类型列表
// export const SERVICE_TYPE_LIST = 'SERVICE_TYPE_LIST';
//服务资源权限列表
// export const RESOURCE_TYPE_PERMISSION_LIST = 'RESOURCE_TYPE_PERMISSION_LIST';
//服务资源列表
export const SERVICE_RESOURCE_LIST = 'SERVICE_RESOURCE_LIST';
export const ADDRESS_LIST_SESSIONSTORAGE = 'addressList'; //sessionStorage id
export const ADDRESS_LIST_EXTERNAL_ID = 'addressListForExternal'; //sessionStorage id
//国际电话号码规则
export const telephoneReg = /^\s*\+?\s*(\(\s*\d+\s*\)|\d+)(\s*-?\s*(\(\s*\d+\s*\)|\s*\d+\s*))*\s*$/g;

export const SEARCH_DAY_VIEW__THE_TIME_INTERVAL_DIV_HEIGHT = 140;
export const SEARCH_DAY_VIEW_THE_TIME_INTERVAL = 1000 * 60 * 30;

export const Meeting = {
  // resourceId: '',//资源类型ID,
  name: '', //会议主题,
  holdId: '', //主持人userID(不带后缀),
  holder: '', //主持人姓名,
  members: '', //参会人userId(不带后缀,多个参会人之间用分号隔开),
  fulds: '', //外部参会人ID,
  startTime: '', //开始时间,
  endTime: '', //结束时间,
  roomIds: '', //会议室ID(多会议室之间用分号隔开),
  isNeedConfirm: 0, //回执支持(0: 不需要|1: 需要),
  remark: '', //备注信息
  type: 0, //会议类型(0: 普通会议|1.周期会议[按天]|2: 周期会议[按周]|3: 周期会议[按月]|4: 周期会议[按年])
  lastTime: '', //会议持续时间(单位为分钟)
  //--------------------------以下数据当type!=0时需传入参数--------------------------
  range: 10, //周期范围(-1: 无结束日期[默认1年]|整数: 重复次数|时间戳: 结束日期)
  rrule: 0, //周期规则: 按天(0.间隔天;1.工作日),按周(0.间隔周数),按月(0.间隔月天数;1.间隔月星期数),按年(0.每年月天数;1.每年月星期数)
  exrule: 0 //周期扩展规则: 按天[每几天: 2(每两天),工作日指周一至周五(默认)]按周[每星期那几天: 0;2;3(周日周二周三)]按月[每几个月几号: 1;2(每个月2号),每几个月第几个星期几: 1;2;0(每个月第二个星期日)]按年[每年几月几号: 1;2(每年1月2号),每年几月第几个星期几: 1;2;3(每年1月第二个星期三)]
};

export const USER_LIST = 'USER_LIST';
export const GROUP_LIST = 'GROUP_LIST';

//用户组权限列表
export const USER_GROUP_PRIVILEGES = 'USER_GROUP_PRIVILEGES';
//用戶權限列表
export const USER_AUTHORITY_LIST = 'USER_AUTHORITY_LIST';
export const GROUP_MAP_UPDATE = 'GROUP_MAP_UPDATE';
export const GROUP_MAP_UPDATE_DEL = 'GROUP_MAP_UPDATE_DEL';
export const GROUP_MAP_UPDATE_ADD = 'GROUP_MAP_UPDATE_ADD';
export const GROUP_MAP_UPDATE_UPDATE = 'GROUP_MAP_UPDATE_UPDATE';

export const ROLES_KEY = {
  admin: 'admin', //系统管理员
  normal: 'normal', //普通用户
  room_admin: 'room_admin', //会议室管理员
  svc_admin: 'svc_admin', //会议服务管理员
  device_admin: 'device_admin', //设备管理员
  reserve_helper: 'reserve_helper' //代订人员
};

export const MEETING_STATUS = {
  pending: 0, //未开始
  opened: 1, //已开始
  closed: 2, //已结束
  cancel: 3, //已取消
  reject: 4, //审核拒绝
  audit: 5, //待审核
  archive: 6, //归档
  agree: 7 //审核通过 ps：这个状态似乎从来没用过？审批通过的会议应该会变成未开始，而不是这个
};
export const MEETING_AUDIT_STATUS = {
  agree: 0, //同意
  reject: 1, //拒绝
  audit: 5 //待审核
};

export const SVC_STATE = {
  //会议服务审批状态
  noApply: 0, //未申请
  audit: 1, //审批中
  reject: 2, //已拒绝
  agree: 3, //已通过
  noAudit: 4 //不需要审批
};

export const SVC_AUDIT_TYPE = {
  //会议服务的审批类型
  no: 0, //不审批
  yes: 1 //审批
};

export const ROOM_NEED_AUDIT = {
  //会议室是否需要审批
  no: 0,
  yes: 1
};

export const ROOM_ALLOW_SVC = {
  //会议室是否允许申请会议服务
  no: 0,
  yes: 1
};

export const MEETING_AUDIT = {
  //会议是否需要审批
  yes: 1, //需要
  no: 0 //不需要
};

export const SYSTEM_AUDIT_TYPE = {
  //项目中的两种审批，0：会议审批，1：会议服务审批
  meeting: 0,
  svc: 1
};
export const SYSTEM_SHOW_MEETING_PRIVATE = {
  // 否允许公开会议主题和预订人信息，0 否，1 是
  yes: 1,
  no: 0
};
export const DEVICE_STATE = {
  NORMAL: 0,
  FAULT: 1
};

//“视频会议”设备的数据库id
export const VIDEO_DEVICE_ID = 110;

export const CLIENT_ID = 'SMT';

export const EXCEPTION_MSG = {
  //后台请求报错时，对错误msg进行优化显示
  zh_40x: '请求异常，请联系管理员。',
  en_40x: 'Request exception, please contact the administrator. ',
  zh_50x: '服务器异常，请联系管理员。',
  en_50x: 'Server exception, please contact the administrator. ',
  zh_err_tip: '错误信息：',
  en_err_tip: 'Error Message:'
};

export const HOLDER_MODAL = 'HOLDER_MODAL'; //选择主持人
export const ATTEND_MODAL = 'ATTEND_MODAL'; //选择参会人
export const VIDEO_PUBLIC_MODAL = 'VIDEO_MODAL';

export const PATH_HOME = process.path;
export const PATHS = {
  meeting: `${PATH_HOME}meeting`,
  list: `${PATH_HOME}list`,
  meetingInfo: `${PATH_HOME}meetingInfo`,
  meetingCtrl: `${PATH_HOME}meetingControl/:meetingId(\\d+)`,
  account: `${PATH_HOME}account`,
  deptUserManage: `${PATH_HOME}account/deptUserManage`,
  roleManage: `${PATH_HOME}account/role`,
  boardManage: `${PATH_HOME}account/board`,
  roomManage: `${PATH_HOME}account/room`,
  serviceManage: `${PATH_HOME}account/service`,
  supportManage: `${PATH_HOME}account/support`,
  deviceManage: `${PATH_HOME}account/device`,
  portManage: `${PATH_HOME}account/interface`,
  log: `${PATH_HOME}account/log`,
  videoManage: `${PATH_HOME}account/video`,
  workDay: `${PATH_HOME}account/workday`,
  noticeManage: `${PATH_HOME}account/notice`,
  audit: `${PATH_HOME}audit`,
  meetingAudit: `${PATH_HOME}audit/meeting`,
  svcAudit: `${PATH_HOME}audit/svc`,
  personalConfig: `${PATH_HOME}personalization`,
  personalization: `${PATH_HOME}personalization/companyInfo`,
  appIndex: `${PATH_HOME}appIndex`,
  license: `${PATH_HOME}license`,
  sysParam: `${PATH_HOME}sysParam`,
  sysLog: `${PATH_HOME}sysLog`,
  report: `${PATH_HOME}report`,
  player: `${PATH_HOME}player`,
  customReport: `${PATH_HOME}report/custom`,
  customReportShow: `${PATH_HOME}report/custom/:reportId(\\d+)`,
  roomLocation: `${PATH_HOME}roomlocation`,
  meetingvideoplayer: `${PATH_HOME}videoplayer`,
  meetingOperate: `${PATH_HOME}meetingoperate`,

  meetingReport: `${PATH_HOME}meetingReport`,
  roomReport: `${PATH_HOME}roomReport`,
  userReport: `${PATH_HOME}userReport`,
  roomReportDetails: `${PATH_HOME}roomReportDetails`,
  roomAbnormallyReport: `${PATH_HOME}roomAbnormallyReport`,
  meetingReleaseReport: `${PATH_HOME}releaseReport`,
  roomOccupyReport: `${PATH_HOME}roomOccupyReport`,
  roomAbnormalDetail: `${PATH_HOME}roomAbnormalDetail`,
  userAbnormallyReport: `${PATH_HOME}userAbnormallyReport`,
  userAbnormalDetail: `${PATH_HOME}userAbnormalDetail`,
  meetingBillReport: `${PATH_HOME}meetingBillReport`,
  controlBoard: `${PATH_HOME}controlBoard`,
  boardMonitor: `${PATH_HOME}controlBoard/monitor`,
  boardFault: `${PATH_HOME}controlBoard/fault`,
  boardAlarm: `${PATH_HOME}controlBoard/alarm`,
  policy: `${PATH_HOME}policy`,
  blank: `${PATH_HOME}blank`, //默认的空白页
  delayMeeting: `${PATH_HOME}delayMeeting`,
  personal: `${PATH_HOME}personal`,
  sysConfig: `${PATH_HOME}sysconfig`,

  test: `${PATH_HOME}test`,
};

export const TIME_FORMAT = {
  date_time: 'YYYY-MM-DD HH:mm',
  date:'YYYY-MM-DD',
  time: 'HH:mm'
};

export const ADMIN_USER_ID = 'admin';

export const SYS_USER_TYPE = {
  //系统用户类型，内部用户0，外部邀请用户1
  internal: 0,
  external: 1,
  all: -1
};

export const USER_FROM = {
  //用户来源
  local: 0, //本地添加
  LDAP: 1, //LDAP同步
  virsical: 2 //威思客同步
};

export const SIGN_TYPE = {
  no: '-1', //不签到
  anonymous: '0', //匿名签到
  password: '1', //安全签到（账户认证签到）
  // inviteCode: '2', //邀请码签到
  // qr: '3', //二维码签到
  // face: '4' //人脸签到
};

export const MEETING_TYPES = {
  local: '1',
  video: '3'
};

export const SEARCH_TYPES = [
  { name: '个人', value: '0' },
  { name: '部门', value: '1' }
];

export const ROOM_CAPACITY = {
  // all: -1, //全部
  common: 0, //普通会议室
  webex: 1, //WebEx会议室
  // acano: 2,//Acano会议室
  exchange: 3, //Exchange会议室
  domino_notes: 4, //Domino|Notes会议室
  google_calendar: 5, //Google Calendar会议室
  cisco_cmma: 6, //Cisco视频会议室
  immediate: 7,//即占即用会议室
};

export const REPORT_DOWNLOAD_MODE = {
  room_usage: 1, //会议室使用率
  room_waste: 2, //会议室浪费率
  video_usage: 3, //设备使用率
  fixed_device: 4, //固定设备统计
  mobile_device: 5, //移动设备统计
  meeting_service: 6, //会议服务统计
  meeting_room: 7, //会议室使用情况统计
  room_cost: 8, //会议室使用费用账单
  user_attend: 9 //出席率
};

export const REPORT_ACTIVE_TYPE = {
  ADD_USER: 'addUser',
  MOD_USER: 'editUser',
  DEL_USER: 'deleteUser',
  USER_COM: 'userCompany',
  REST_PWD: 'resetPwd',
  ADD_ROLE: 'addRole',
  MOD_ROLE: 'editRole',
  DEL_ROLE: 'deleteRole',
  ADD_ROLE_USER: 'addRoleUser',
  DEL_ROLE_USER: 'deleteRoleUser',
  ADD_BOARD_TEMP: 'addBoardTemp',
  MOD_BOARD_TEMP: 'editBoardTemp',
  DEL_BOARD_TEMP: 'deleteBoardTemp',
  ADD_REGION: 'addRegion',
  MOD_REGION: 'editRegion',
  DEL_REGION: 'deleteRegion',
  ORD_REGION: 'orderRegion',
  ADD_ROOM: 'addRoom',
  MOD_ROOM: 'editRoom',
  DEL_ROOM: 'deleteRoom',
  BIND_ROOM: 'bindRoom',
  ADD_SRV_LV: 'addServiceLevel',
  MOD_SRV_LV: 'editServiceLevel',
  DEL_SRV_LV: 'deleteServiceLevel',
  ADD_SRV_ITEM: 'addServiceItem',
  MOD_SRV_ITEM: 'editServiceItem',
  DEL_SRV_ITEM: 'deleteServiceItem',
  ADD_DEVICE: 'addDevice',
  MOD_DEVICE: 'editDevice',
  DEL_DEVICE: 'deleteDevice',
  EDIT_DEVICE_STATE: 'editDeviceState',
  LEND_STATE: 'lendState',
  SAVE_EXCH: 'saveExchange',
  CONN_EXCH: 'connectExchange',
  DIS_CONN_EXCH: 'disconnectExchange',
  HOLIDAY_MANAGE: 'holidayManage',
  FRONT_DESK: 'frontDesk',
  ADD_SUPPORT: 'addSupport',
  MOD_SUPPORT: 'editSupport',
  DEL_SUPPORT: 'deleteSupport'
};

export const REPORT_ACTIVE_TYPE_MAP = [
  { key: 'addUser', value: '添加用户', EnValue: 'Add user' },
  { key: 'editUser', value: '编辑用户', EnValue: 'Edit user' },
  { key: 'deleteUser', value: '删除用户', EnValue: 'Delete users' },
  /*{key: 'userCompany', value: '通讯录授权',EnValue:'Address book authorization'},
  {key: 'resetPwd', value: '密码重置',EnValue:'Reset Password'},*/
  { key: 'addRole', value: '新增角色', EnValue: 'Add role' },
  { key: 'editRole', value: '编辑角色', EnValue: 'Edit role' },
  { key: 'deleteRole', value: '删除角色', EnValue: 'Delete role' },
  { key: 'addRoleUser', value: '添加角色用户', EnValue: 'Add role user' },
  { key: 'deleteRoleUser', value: '删除角色用户', EnValue: 'Delete role user' },
  {
    key: 'addBoardTemp',
    value: '添加预约屏模板',
    EnValue: 'Add appointment screen template'
  },
  {
    key: 'editBoardTemp',
    value: '编辑预约屏模板',
    EnValue: 'Edit appointment screen template'
  },
  {
    key: 'deleteBoardTemp',
    value: '删除预约屏模板',
    EnValue: 'Delete appointment screen template'
  },
  { key: 'addRegion', value: '添加区域', EnValue: 'Add region' },
  { key: 'editRegion', value: '编辑区域', EnValue: 'Edit region' },
  { key: 'deleteRegion', value: '删除区域', EnValue: 'Delete region' },
  /*{key: 'orderRegion', value: '区域排序',EnValue:'Order region'},*/
  { key: 'addRoom', value: '添加会议室', EnValue: 'Add meeting room' },
  { key: 'editRoom', value: '编辑会议室', EnValue: 'Edit meeting room' },
  { key: 'deleteRoom', value: '删除会议室', EnValue: 'Delete meeting room' },
  { key: 'bindRoom', value: '绑定会议室管理员', EnValue: 'Bind room manager' },
  {
    key: 'addServiceLevel',
    value: '添加会议服务等级',
    EnValue: 'Add meeting service level'
  },
  {
    key: 'editServiceLevel',
    value: '编辑会议服务等级',
    EnValue: 'Edit meeting service level'
  },
  {
    key: 'deleteServiceLevel',
    value: '删除会议服务等级',
    EnValue: 'Delete meeting service level'
  },
  {
    key: 'addServiceItem',
    value: '添加会议服务项',
    EnValue: 'Add meeting service item'
  },
  {
    key: 'editServiceItem',
    value: '编辑会议服务项',
    EnValue: 'Edit meeting service item'
  },
  {
    key: 'deleteServiceItem',
    value: '删除会议服务项',
    EnValue: 'Delete meeting service item'
  },
  { key: 'addDevice', value: '添加设备', EnValue: 'Add device' },
  { key: 'editDevice', value: '编辑设备', EnValue: 'Edit device' },
  { key: 'deleteDevice', value: '删除设备', EnValue: 'Delete device' },
  {
    key: 'editDeviceState',
    value: '维护设备状态',
    EnValue: 'Update device state'
  },
  { key: 'lendState', value: '设备借还', EnValue: 'Equipment loan' },
  {
    key: 'saveExchange',
    value: '保存Exchange配置',
    EnValue: 'Save Exchange config'
  },
  {
    key: 'connectExchange',
    value: '打开Exchange连接',
    EnValue: 'Open Exchange connection'
  },
  {
    key: 'disconnectExchange',
    value: '关闭Exchange连接',
    EnValue: 'Close Exchange connection'
  },
  { key: 'holidayManage', value: '工作日管理', EnValue: 'Working day manage' },
  /* {key: 'frontDesk', value: '设置前台号码',EnValue:'Set the front number'},
  {key: 'addSupport', value: '添加会议支持项',EnValue:'Add meeting support'},
  {key: 'editSupport', value: '编辑会议支持项',EnValue:'Edit meeting support'},
  {key: 'deleteSupport', value: '删除会议支持项',EnValue:'Delete meeting support'},*/
  {
    key: 'meetingRelease',
    value: '红外结束会议',
    EnValue: 'Infrared end meeting'
  }
];

export const DEFAULT_MAX_ORD = 1000000;

export const AES_KEY = 'wafer123wafer123';

export const REQUEST_STATUS = {
  success: 0,
  failure: 1
};

export const LAYOUTS = {
  speakerOnly: 'speakerOnly', //全屏
  telepresence: 'telepresence', //网真
  stacked: 'stacked', //堆叠
  allEqual: 'allEqual', //对等
  allEqualQuarters: 'allEqualQuarters', //2*2
  allEqualNinths: 'allEqualNinths', //3*3
  allEqualSixteenths: 'allEqualSixteenths', //4*4
  allEqualTwentyFifths: 'allEqualTwentyFifths', //5*5
  onePlusN: 'onePlusN', //1+n
  onePlusFive: 'onePlusFive', //1+5
  onePlusSeven: 'onePlusSeven', //1+7
  onePlusNine: 'onePlusNine' //1+9
};

export const RES_STATUS = {
  success: 0,
  failure: 1,
  tokenFail: 8
};

export const PARTICIPANT_STATUS = {
  ringing: 'ringing',
  connected: 'connected',
  unknown: 'unknown'
};

export const ROTATION_MODE = {
  //轮询模式
  single: 'SINGLE_VIEW',
  multi: 'MULTIPLE_VIEW'
};

export const ROTATION_DURATIONS = [10, 20, 30];

export const TERMINAL_STATUS = {
  terminal: 0,
  room: 1
};

export const ADD_ROOM_STATUS = {
  success: 0,
  inuse: 1,
  filure: 2
};

export const DEFAULT_CANCEL_TYPE = 0;

export const INDEX_CONFIG_KEY = {
  BOOK_KEY: 'BOOKING',
  ABOUT_KEY: 'ABOUT',
  VIDEO_MEETING_KEY: 'VIDEO_MEETING',
  MY_MEETING_KEY: 'MY_MEETING',
  INITIATE_KEY: 'INITIATE_MEETING',
  WEBEX_MEETING_KEY: 'WEBEX_MEETING'
};

export const INSTALLER_MENU = [
  {
    id: 1,
    image: 'setting',
    menuDesc: '配置系统所有参数',
    name: '系统参数配置',
    url: 'sysParam',
    children: []
  },
  {
    id: 2,
    image: 'setting',
    menuDesc: '配置系统相关信息',
    name: '系统策略配置',
    url: 'policy',
    children: []
  },
  {
    id: 3,
    image: 'setting',
    menuDesc: '配置APP首页功能',
    name: 'App首页配置',
    url: 'appIndex',
    children: []
  },
  {
    id: 4,
    image: 'setting',
    menuDesc: '系统日志下载功能',
    name: '日志下载',
    url: 'sysLog',
    children: []
  },  {
    id: 5,
    image: 'setting',
    menuDesc: '配置license',
    name: 'license 配置',
    url: 'license',
    children: []
  }
];

export const MEETING_FILTER_TYPE = {
  myBook: '1',
  myAttend: '2',
  myManage: '3'
};

export const USER_SIGN_TYPE = {
  NONE:0,//未签到
  PWD:1,//密码签到
  QR_CODE:2,//扫码签到
  FACE:3,//人脸识别签到
  INFRARED:4,//红外签到
  SUPPLEMENT_SIGN:5,//补签
  ANONYMOUS:6,//匿名签到
  DOOR_ACCESS:7,//门禁签到
};

export const MT_RLS_KIND = [
  'mt_rls_kind_cancel',
  'mt_rls_kind_normal',
  'mt_rls_kind_unsigned'
];

export const MT_RLS_TYPE = [
  'mt_rls_type_cancel',
  'mt_rls_type_unsigned',
  'mt_rls_type_early',
  'mt_rls_type_infrared',
  'mt_rls_type_time_up',
  'mt_rls_type_delay',
  'mt_rls_type_reject',
  'mt_rls_type_third_syn',
  'mt_rls_type_all_refused',
  'mt_rls_type_room_maintain',
  'mt_rls_type_room_visible'
];

export const MAINTAIN_STATUS = {
  not_set: 0,
  not_start: 1,
  started: 2
};

export const RLS_KIND = {
  cancel: 0,
  normal: 1,
  unsigned: 2
};

export const RLS_TYPE = {
  notRls: 0,
  cancel: 1,
  unsigned: 2,
  end: 3,
  hw: 4,
  timeUp: 5,
  delayEnd: 6,
  reject: 7,
  thirdSyn: 8,
  allRefused: 9,
  roomMaintain: 10
};

export const LIVE_TYPE = {
  normal: 'Generic',
  asr: 'Asr'
}

export const CALENDAR_TIME_TYPE = {
  day: 'd',
  week: 'w'
};



// WEBPACK FOOTER //
// ./src/utils/constants.js